export default __webpack_public_path__ + "static/media/FEMI SUIT - Product Management Practice Lead.b736ab70.png";